import { render } from "./AppLogAccessi.vue?vue&type=template&id=7f54745a&scoped=true"
import script from "./AppLogAccessi.vue?vue&type=script&lang=js"
export * from "./AppLogAccessi.vue?vue&type=script&lang=js"

import "./AppLogAccessi.vue?vue&type=style&index=0&id=7f54745a&scoped=true&lang=css"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f54745a"]])

export default __exports__